import { render, staticRenderFns } from "./ActionMenu.vue?vue&type=template&id=137fe257&scoped=true&"
import script from "./ActionMenu.vue?vue&type=script&lang=ts&"
export * from "./ActionMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ActionMenu.vue?vue&type=style&index=0&id=137fe257&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137fe257",
  null
  
)

export default component.exports